module.exports = __webpack_public_path__ + "roboto-v15-latin-300.1edaa6e50c2302bf0221.svg";


//////////////////
// WEBPACK FOOTER
// /app/src/assets/layout/fonts/roboto-v15-latin-300.svg
// module id = ../../../../../src/assets/layout/fonts/roboto-v15-latin-300.svg
// module chunks = 2